/**
 * Keys cleared when the customer portal session ends (logout or 401).
 * Keep in sync with AuthContext.logout.
 *
 * @param {{ preserveOrgPublicId?: boolean }} [options] If true, keeps organization_public_id (e.g. expired token → send user back to /:org/login).
 */
export function clearCustomerPortalSession(options = {}) {
  const preserveOrg = options.preserveOrgPublicId === true;
  localStorage.removeItem('customer_token');
  localStorage.removeItem('customer_user');
  if (!preserveOrg) {
    localStorage.removeItem('organization_public_id');
  }
  localStorage.removeItem('organization_name');
  localStorage.removeItem('organization_logo');
  localStorage.removeItem('organization_cover');
  localStorage.removeItem('organization_show_logo');
  localStorage.removeItem('organization_show_cover');
  localStorage.removeItem('organization_tagline');
  localStorage.removeItem('organization_description');
  localStorage.removeItem('organization_phone');
  localStorage.removeItem('organization_email');
  localStorage.removeItem('organization_website_url');
  localStorage.removeItem('organization_website_name');
}
